import React from 'react'

const Loader = () => {
  return (
    // Loading Bar - find styling in index.css
    <div className="load-bar">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>
  )
}

export default Loader